import { render, staticRenderFns } from "./AnnouncementDialog.vue?vue&type=template&id=32f71567&scoped=true"
import script from "./AnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./AnnouncementDialog.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDialog.vue?vue&type=style&index=0&id=32f71567&prod&lang=css"
import style1 from "./AnnouncementDialog.vue?vue&type=style&index=1&id=32f71567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f71567",
  null
  
)

export default component.exports